const purchaseAnalytics = document.querySelector('.sc-purchase-process-info-03[data-analytics-purchase]');

if (purchaseAnalytics) {
  try {
    pushEcommerceEvent('purchase', JSON.parse(purchaseAnalytics.dataset.analyticsPurchase));
  } catch (err) {
    console.error(err);
  }
}
